import React from 'react';
import { Checkbox } from 'antd';

export const columns = [
  {
    title: 'Id',
    dataIndex: 'id',
    key: 'id',
    sorter: (a, b) => a.id - b.id,
    showOnEdit: true,
    type: 'number',
    editable: false,
    creatable: false,
  },
  {
    title: 'Inactive Ind',
    dataIndex: 'inactiveInd',
    key: 'inactiveind',
    render: (value) => <Checkbox checked={value} />,
    showOnEdit: true,
    type: 'boolean',
    editable: true,
    creatable: true,
  },
  {
    title: 'Element Attribute Type Id',
    dataIndex: 'elementAttributeType',
    render: (value) => value?.id,
    key: 'elementAttributeTypeId',
    showOnEdit: true,
    type: 'number',
    editable: false,
    creatable: true,
    isForeignKey: true,
  },
  {
    title: 'Element Attribute Type Name',
    dataIndex: 'elementAttributeType',
    render: (value) => value?.name,
    key: 'elementAttributeTypeName',
    showOnEdit: false,
    type: 'string',
    editable: false,
    creatable: false,
  },
  {
    title: 'Element Attribute Type Inactive Ind',
    dataIndex: 'elementAttributeType',
    key: 'elementAttributeTypeInactiveInd',
    render: (value) => <Checkbox checked={value.inactiveInd} />,
    showOnEdit: false,
    type: 'boolean',
    editable: false,
    creatable: false,
  },
  {
    title: 'Default Value',
    dataIndex: 'defaultValue',
    key: 'defaultValue',
    showOnEdit: true,
    type: 'string',
    editable: true,
    creatable: true,
  },
  {
    title: 'Add To Form Spec',
    dataIndex: 'addToFormSpec',
    key: 'addToFormSpec',
    render: (value) => <Checkbox checked={value} />,
    showOnEdit: true,
    type: 'boolean',
    editable: true,
    creatable: true,
  },
  {
    title: 'Can Edit In Form Builder',
    dataIndex: 'canEditInFormBuilder',
    key: 'canEditInFormBuilder',
    render: (value) => <Checkbox checked={value} />,
    showOnEdit: true,
    type: 'boolean',
    editable: true,
    creatable: true,
  },
];

export const extraColumns = [];
